import { useSelector } from "react-redux";
import { Field } from "redux-form/immutable";

import {
  Box,
  Button,
  Column,
  Columns,
  TextButton,
  Tiles
} from "@seneca/senekit";

import SchoolsDropdownMenu from "features/common/forms/components/SchoolsDropdownMenu";
import SubjectDropdown from "features/common/forms/components/SubjectDropdown";
import { isMobile } from "features/common/utils/functions/mobile";
import { FormDropdown } from "features/forms/components/FormDropdownMenu";
import { FormTextInput } from "features/forms/components/FormTextInput";
import { getCollectTeacherRole } from "features/regions/selectors";
import ErrorMessage from "features/sign-up/components/ErrorMessage";
import SignUpWithProgressBarWrapper from "features/sign-up/components/SignUpWithProgressBarWrapper";
import { TeacherRoleOptions } from "features/user/consts";

type Props = {
  handleSubmit: () => void;
  submitting: boolean;
  error: string;
  onBackClick: () => void;
  pageNumber: number;
  totalNumberOfPages: number;
  includeSchool: boolean;
  loading: boolean;
};

export default function SignUpFormTeacherDetails({
  handleSubmit,
  submitting,
  error,
  onBackClick,
  pageNumber,
  totalNumberOfPages,
  includeSchool,
  loading
}: Props) {
  const collectTeacherRole = useSelector(getCollectTeacherRole);

  return (
    <SignUpWithProgressBarWrapper
      header="Complete your account"
      pageNumber={pageNumber}
      totalNumberOfPages={totalNumberOfPages}
    >
      <Box component="form" onSubmit={handleSubmit} width="100%">
        <Tiles columns={[1, 2]} space="xlarge">
          {includeSchool && (
            <Field name="school" component={SchoolsDropdownMenu} />
          )}

          <Field
            name="nickname"
            component={FormTextInput}
            type="text"
            label="Students call you"
          />

          {collectTeacherRole && (
            <Field
              name="teacherRole"
              component={FormDropdown}
              options={TeacherRoleOptions}
              label="Role"
              placeholder="Select your role"
              isSearchable={!isMobile()}
            />
          )}
          <Field
            name="teacherSubjects"
            label="Subjects taught"
            component={SubjectDropdown}
          />
        </Tiles>

        <ErrorMessage>{error}</ErrorMessage>

        <Columns
          collapseBelow="tablet"
          reverseOnCollapse
          alignY="baseline"
          alignX="center"
          space="xlarge"
        >
          <Column alignX={["center", "flex-start"]}>
            <TextButton size="medium" onClick={onBackClick}>
              Previous step
            </TextButton>
          </Column>
          <Column alignX={["center", "flex-end"]}>
            <Button
              onClick={() => {}}
              loading={submitting || loading}
              disabled={submitting || loading}
            >
              Finish sign up
            </Button>
          </Column>
        </Columns>
      </Box>
    </SignUpWithProgressBarWrapper>
  );
}
